export const initialMobileVerify = {
  //step1
  mobile_no: '',
  // step-2
  otp: '',
}

export const initialMobileVerifyErrors = {
  //step1
  mobile_no: '',
  // step-2
  otp: '',
}